/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_SubtitleInputs */

const en_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Characterful apartments in central Belgrade, cared for by a local team from booking to check-out.`)
};

/**
* | output |
* | --- |
* | "Characterful apartments in central Belgrade, cared for by a local team from booking to check-out." |
*
* @param {Home_Hero_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_hero_subtitle = /** @type {((inputs?: Home_Hero_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_hero_subtitle(inputs)
});